import React from 'react'
import { FormattedMessage } from 'react-intl'
import classNames from 'classnames'
import Typography from '@material-ui/core/Typography'
import useStyles from './styles'

const TCBlock = ({ title, values, children }) => {
  const classes = useStyles()

  return (
    <div>
      <Typography className={classNames(classes.upperCaseText, classes.title)}>
        <FormattedMessage id={title} values={values} />
      </Typography>
      <div>{children}</div>
    </div>
  )
}

export default TCBlock
